import type { ReactNode } from "react";
import { marketingUrl } from "../config/marketing";
import { includedPoints } from "../lib/portalCopy";
import { Emblem } from "./AccountShell";
import { IconCheck } from "./icons";
import { Seal } from "./Seal";

interface AuthLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export function AuthLayout({ title, description, children }: AuthLayoutProps) {
  return (
    <div className="auth">
      <aside className="auth__side">
        <a className="brand" href={marketingUrl("/")}>
          <Emblem />
          <span className="brand__name">
            Capital Pilot
            <small>Konto</small>
          </span>
        </a>
        <Seal className="auth__seal" seed="capital-pilot" size={320} />
        <ul className="auth__facts">
          {includedPoints("customer").slice(0, 3).map((point) => (
            <li key={point}>
              <IconCheck />
              {point}
            </li>
          ))}
        </ul>
      </aside>

      <main className="auth__main">
        <div className="auth__panel">
          <header className="auth__head">
            <h1>{title}</h1>
            {description ? <p>{description}</p> : null}
          </header>
          {children}
        </div>
        <footer className="auth__foot">
          <a href={marketingUrl("/")}>Website</a>
          <a href={marketingUrl("/datenschutz")}>Datenschutz</a>
          <a href={marketingUrl("/impressum")}>Impressum</a>
        </footer>
      </main>
    </div>
  );
}
